module.exports = __webpack_public_path__ + "img/bruush.3b6200be.png";